import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  TextField,
  FormHelperText,
} from "@mui/material";

const InfoStep = ({ formData, formErrors, handleChange }) => {
  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.name}>
        <FormLabel>Name</FormLabel>
        <TextField
          name="name"
          type="text"
          placeholder="Enter Playlist Name"
          value={formData.name}
          onChange={handleChange}
          variant="outlined"
        />
        {formErrors.name && <FormHelperText>{formErrors.name}</FormHelperText>}
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.description}>
        <FormLabel>Description</FormLabel>
        <TextField
          name="description"
          type="text"
          placeholder="Enter Playlist Description"
          value={formData.description}
          onChange={handleChange}
          variant="outlined"
        />
        {formErrors.description && (
          <FormHelperText>{formErrors.description}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.ppsNumber}>
        <FormLabel>PPS Number</FormLabel>
        <TextField
          name="ppsNumber"
          type="text"
          placeholder="Enter PPS Number"
          value={formData.ppsNumber}
          onChange={handleChange}
          variant="outlined"
        />
        {formErrors.ppsNumber && (
          <FormHelperText>{formErrors.ppsNumber}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.worksite}>
        <FormLabel>Worksite</FormLabel>
        <TextField
          name="worksite"
          type="text"
          placeholder="Enter Worksite"
          value={formData.worksite}
          onChange={handleChange}
          variant="outlined"
        />
        {formErrors.worksite && (
          <FormHelperText>{formErrors.worksite}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.startDateTime}>
        <FormLabel>Start Date</FormLabel>
        <TextField
          name="startDateTime"
          type="date"
          value={formData.startDateTime}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        {formErrors.startDateTime && (
          <FormHelperText>{formErrors.startDateTime}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.endDateTime}>
        <FormLabel>End Date</FormLabel>
        <TextField
          name="endDateTime"
          type="date"
          value={formData.endDateTime}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        {formErrors.endDateTime && (
          <FormHelperText>{formErrors.endDateTime}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default InfoStep;
